/* eslint-disable react/jsx-no-bind */
import CartHelper from "../../shared/modules/CartHelper";
import PropTypes from "prop-types";
import React from "react";

const NonMemberAddressInfo = ({addressInfo, setIsEditingAddress}) => {
  const {
    "first_name": firstName,
    "last_name": lastName,
    "street_address_1": streetAddressOne,
    "street_address_2": streetAddressTwo
  } = addressInfo;
  const {zip, city, state} = addressInfo;

  const handleEditAddressInfo = () => {
    setIsEditingAddress(true);
  };

  const hasValidAddressInfo = () => CartHelper.hasValidAddressInfo(addressInfo);

  if (!hasValidAddressInfo()) return null;
  return (
    <div className="address-info cart-block">
      <div className="header">
        <div className="title">
          shipping & contact
        </div>
        {!hasValidAddressInfo() &&
          <div className="quantity-field">
            <div
              className="increase-quantity-button increase-btn"
              onClick={handleEditAddressInfo}
              type="button"
            />
          </div>
        }
        {
          hasValidAddressInfo() &&
          <a onClick={handleEditAddressInfo}>
            Edit
          </a>
        }
      </div>
      {hasValidAddressInfo() &&
        <div className="mt-1">
          <div className="first-name">
            {firstName}
            {" "}
            {lastName}
          </div>
          <div className="last-name">
            {streetAddressOne}
            {" "}
            {streetAddressTwo}
          </div>
          <div className="location">
            {zip}
            {" "}
            {city}
            ,
            {" "}
            {state}
          </div>
        </div>
      }
    </div>
  );
};

NonMemberAddressInfo.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired
};

export default NonMemberAddressInfo;
